import React, { useState, useRef } from "react";

const FAQ = () => {
  const [height, setHeight] = useState(90);
  const [accordian, setAccordian] = useState(false);
  const inputWidth = useRef(null);
  const toggleAccordian = () => {
    if (accordian) {
      setAccordian(false);
      setHeight(90);
      return;
    }
    setAccordian(true);
    setHeight(inputWidth.current.clientHeight);
  };
  return (
    <>
      <div className="headline_panel">
        <h2 className="title">Frequently Asked Questions</h2>
      </div>
      <div
        className={accordian ? "accordion active" : "accordion"}
        onClick={toggleAccordian}
        style={{ maxHeight: height }}
      >
        <div className="wrap" ref={inputWidth}>
          <div className="item">
            <span className="question">What do I get?</span>
          </div>
          <div className="item">
            <span className="answer">
              Exclusive access to the friends you’ve always wanted and new ones
              you didn't know about.
            </span>
          </div>
          <div className="item">
            <span className="question">What is "My Library"?</span>
          </div>
          <div className="item">
            <span className="answer">
              You can purchase videos to add to your library. These videos you
              will be able to download as well as view them even when your
              membership to your friend has expired.
            </span>
          </div>
          <div className="item">
            <span className="question">Where is my library?</span>
          </div>
          <div className="item">
            <span className="answer">
              It is located in your favorites (the heart icon), there is a tab
              called "My Library" when you get to that page.
            </span>
          </div>
          {/* <div className="item">
            <span className="question">
              Why can't I see videos in Snapchat?
            </span>
          </div>
          <div className="item">
            <span className="answer">
              Please verify that your snapname is correct in your profile. If
              that's right and you're still not seeing any posts from your
              friend, please <a href="/contact-us">Contact Us</a>.
            </span>
          </div>
          <div className="item">
            <span className="question">
              Are Screenshots and screen recordings ok?
            </span>
          </div>
          <div className="item">
            <span className="answer">Yes, unless stated otherwise.</span>
          </div> */}
          <div className="item">
            <span className="question">Need help?</span>
          </div>
          <div className="item">
            <span className="answer">
              If you have an issue please use{" "}
              <a href="/contact-us">our contact form</a> and expect a fast
              reply.
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default FAQ;
